/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./headerMap.vue?vue&type=template&id=80d1a578&scoped=true"
import script from "./headerMap.vue?vue&type=script&lang=js"
export * from "./headerMap.vue?vue&type=script&lang=js"
import style0 from "./headerMap.vue?vue&type=style&index=0&id=80d1a578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d1a578",
  null
  
)

export default component.exports